module.exports = __webpack_public_path__ + "static/img/103441.afaf1bbe.png";